import { createApp } from 'vue'
import alert from './plugins/alert'
import confirm from './plugins/confirm'
import loading from './plugins/loading'
import actionSheets from './plugins/actionSheets'
import chooseOption from './plugins/chooseOption'
import './assets/styles.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueLazyLoad from 'vue3-lazyload'

//axios.defaults.baseURL = 'http://localhost:5025/api/';
axios.defaults.baseURL = 'https://qa-api.marca-blanca.invarat.mx/api/';
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios;

const app = createApp(App)

// Obtener color_base desde localStorage
const colorBase = localStorage.getItem('color_base') || '#fd7527' 

// Actualizar variable CSS global
document.documentElement.style.setProperty('--primary-color', colorBase)

//app.config.globalProperties.$evidenceUrl = "http://localhost:5025/api/ajustes/evidences/download"
//app.config.globalProperties.$logoUrl = "http://localhost:5025/api/aseguradoras/logo/download"
app.config.globalProperties.$evidenceUrl = "https://qa-api.marca-blanca.invarat.mx/api/ajustes/evidences/download"
app.config.globalProperties.$logoUrl = "https://qa-api.marca-blanca.invarat.mx/api/aseguradoras/logo/download"
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6sKGpA6jpHJBVVR1okiiM2oz7dherI5o',
  },
})

app.component('VueDatePicker', VueDatePicker);

app.use(router)

app.use(alert)

app.use(confirm)

app.use(loading)

app.use(actionSheets)

app.use(chooseOption)

app.use(VueLazyLoad)

app.mount('#app')
